import React from 'react';
import { PlusCircle } from 'lucide-react';
import { t } from '../i18n';
import './PracticePoolRecommendation.css';

export default function PracticePoolRecommendation({ level }) {
  if (![1, 2, 3].includes(level)) return null;
  return (
    <p className={`practice-pool-recommendation is-level-${level}`} role="status">
      <PlusCircle size={18} aria-hidden="true" />
      <span>{t(`dashboard.practicePool.level${level}`)}</span>
    </p>
  );
}
